// Бэкенд (ms-admin, /api/admin/user/misc/role) отдаёт только код роли Keycloak
// (CD_RESIDENT и т.п.), человекочитаемое название есть только в самом Keycloak
// (поле description роли) и наружу через API не отдаётся — поэтому подписи
// для админки заведены здесь. Список ролей соответствует
// cyberdom-app.realm.json в ~/AB/cyberdom-backend/ms-auth-core-keycloak.
export const USER_ROLE_LABELS: Record<string, string> = {
    CD_ANONYMOUS: 'Аноним',
    CD_GUEST: 'Гость',
    CD_RESIDENT: 'Резидент',
    // CD_INSIDER технически так и называется в Keycloak, но по смыслу и во всех
    // текстах уведомлений бэкенда это роль «Амбассадор» — используем её как есть,
    // не заводя отдельную роль.
    CD_INSIDER: 'Амбассадор',
    CD_FRIEND: 'Друг',
};

// Роли, которые входят в раздел "Клуб" — держим в одном месте с бэкендом
// (см. FetchClubUsersProcessor.clubRoles в ms-admin), чтобы подписи совпадали.
export const CLUB_ROLE_CODES = ['CD_RESIDENT', 'CD_INSIDER'];

export function userRoleLabel(code?: string | null): string {
    if (!code) return '—';
    return USER_ROLE_LABELS[code] ?? code;
}
